module.exports = __webpack_public_path__ + "static/img/Jack-Bird.9b3f26d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-Bird.jpg
// module id = IGp9
// module chunks = 0